import { bootstrapApplication } from '@angular/platform-browser'

import * as Sentry from '@sentry/angular'

import { initAmplify } from '@ti/core/auth/utils'
import { initGtag, whenMainThreadSettles } from '@ti/core/common/utils'
import { FleetAppComponent } from '@ti/fleet/shell/components/app/fleet-app.component'

import { appConfig } from './app/app.config'
import env from './env'
import { APP_VERSION } from './env/version'

const isE2eEnv = 'Cypress' in window
const isLocalhost =
  window?.location?.hostname === 'localhost' || window?.location?.hostname === '127.0.0.1'

if (env.googleTagManagerId && !isLocalhost && !isE2eEnv) {
  whenMainThreadSettles().then(() => initGtag(env.googleTagManagerId))
}

const isSentryEnabled = env.sentry.enabled && !isLocalhost && !isE2eEnv

Sentry.init({
  dsn: env.sentry.dsn,
  release: `${env.sentry.project}@${APP_VERSION}`,
  enabled: isSentryEnabled,
  ignoreErrors: ['UserUnAuthenticatedException'],
  integrations: [Sentry.browserTracingIntegration()],
  // Performance Monitoring
  tracesSampleRate: 0.5, //  Capture 50% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: env.sentry.tracePropagationTargets,
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

// Replay snapshots the whole DOM as it starts; addIntegration also installs on a disabled client
if (isSentryEnabled) {
  whenMainThreadSettles().then(() => {
    // Replay reads the canvas options only as it is added
    Sentry.addIntegration(Sentry.replayCanvasIntegration())
    Sentry.addIntegration(
      Sentry.replayIntegration({
        networkDetailAllowUrls: [`${env.apiUrl}/*`],
        maskAllText: false,
        blockAllMedia: false,
      }),
    )
  })
}

initAmplify(
  {
    userPoolId: env.amplify.userPoolId,
    identityPoolId: env.amplify.identityPoolId,
    userPoolClientId: env.amplify.userPoolClientId,
  },
  {
    resolveSessionUrl: `${env.apiUrl}/fleet/user/login-session`,
    sessionIdParamName: 'sessionId',
  },
).then(() => {
  bootstrapApplication(FleetAppComponent, appConfig).catch((e: Error) =>
    console.error(`Cannot bootstrap application`, e),
  )
})
